<template>
  <div class="base">
    <inside-header color="#fff" title="微信绑定" />
    <div class="main">
      <div v-if="!loading && wx_auth_status" class="bind-area">
        <a-alert message="您已绑定了微信 [小橙家教发送的各类系统、订单、服务通知将实时发送到您的关注我们的微信公众号上]" banner />
        <div style="margin-top: 20px">
          <a-button :loading="state.unBindWechatBtn" @click="goUnBindWechat">
            获取解绑二维码
          </a-button>
        </div>
      </div>
      <div v-if="!loading && !wx_auth_status" class="unbind">
        <a-alert message="绑定微信后平台可通过微信方式发送订单，教员消息，系统消息等通知。建议尽快绑定，感受更贴心的服务" banner />
        <div style="margin-top: 20px">
          <a-button :loading="state.bindWechatBtn" @click="goBindWechat">
            获取绑定二维码
          </a-button>
        </div>
      </div>
      <div v-show="wechatBindVisible" style="margin-top: 20px;">
        <div id="qrcode" ref="qrcode" style="width: 280px;height: 280px;margin: auto" />
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
import QRCode from 'qrcodejs2'

export default {
  name: 'UserSetting',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      loading: false,
      state: {
        bindWechatBtn: false,
        unBindWechatBtn: false
      },
      wx_auth_status: false,
      qrcode: null,
      profile: {},
      wechatBindVisible: true
    }
  },
  watch: {
    profile(data) {
      console.log('assss')
      if (data.wx_auth_status === 1) {
        this.wx_auth_status = true
      } else {
        this.wx_auth_status = false
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: '/index/teacher/security',
        method: 'get',
        params: {
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          const data = res.data
          this.profile = data.profile
          console.log(data)
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    bindQRCode(text) {
      // 清楚插件生成的二维码图片
      document.getElementById('qrcode').innerHTML = ''
      var qrcode = new QRCode('qrcode', {
        text: text,
        width: 280,
        height: 280,
        colorDark: '#333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.H
      })
      this.qrcode = qrcode
    },
    goBindWechat() {
      const that = this
      this.state.bindWechatBtn = true
      this.$http({
        url: '/index/wechat/bind',
        method: 'get'
      }).then(res => {
        this.state.bindWechatBtn = false
        if (res.status === 'success') {
          console.log(res)
          const scanUrl = res.data.scan_url
          // 显示模态框后开始处理二维码
          setTimeout(function () {
            that.wechatBindVisible = true
            that.bindQRCode(scanUrl)
            that.$toast.success('请使用微信扫描二维码')
            // 开始轮询
          }, 1000)
          that.queryWechatBindStatus()
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    // 解绑微信
    goUnBindWechat() {
      const that = this
      this.state.unBindWechatBtn = true
      this.$http({
        url: '/index/wechat/unbind',
        method: 'get'
      }).then(res => {
        this.state.unBindWechatBtn = false
        if (res.status === 'success') {
          console.log(res)
          const scanUrl = res.data.scan_url
          // 显示模态框后开始处理二维码
          setTimeout(function () {
            that.wechatBindVisible = true
            that.bindQRCode(scanUrl)
            that.$toast.success('请使用微信扫描二维码')
            // 开始轮询
          }, 1000)
          that.queryWechatUnBindStatus()
        } else {
          this.$notification.error({
            message: '获取扫描二维码失败',
            description: res.message
          })
        }
      })
    },
    // 解绑微信
    queryWechatUnBindStatus() {
      const that = this
      that.queryWechatUnBindcron = setInterval(function () {
        that.$http({
          url: '/index/wechat/queryBindStatus',
          method: 'get'
        }).then(res => {
          if (res.status === 'success') {
            // 如果解除绑定成功
            if (!res.data.isbind) {
              that.wechatBindVisible = false
              that.loadData()
              that.$toast.success('微信解除绑定成功')
              clearInterval(that.queryWechatUnBindcron)
            }
          }
        })
      }, 3000)
    },
    queryWechatBindStatus() {
      const that = this
      that.queryWechatBindcron = setInterval(function () {
        that.$http({
          url: '/index/wechat/queryBindStatus',
          method: 'get'
        }).then(res => {
          if (res.status === 'success') {
            // 如果绑定成功
            if (res.data.isbind) {
              that.wechatBindVisible = false
              that.loadData()
              that.$toast.success('微信绑定成功')
              clearInterval(that.queryWechatBindcron)
            }
          }
        })
      }, 3000)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;
  }

  .logout-btn {
    margin-top: 20px;
    .van-button__content {
      span {
        color: #333333;
      }
    }
  }

  .submit-area {
    margin-top: 35px;
    .submit-btn {
      border-radius: 10px;
    }
  }
</style>
